import { ConfirmDialog, useToast } from "@nabble/ui";
import type { AccountInfo } from "../../../../api/account";
import { cancelPendingEmail } from "../../../../api/accountEmails";
import { emailErrorMessage } from "./emailErrors";

interface CancelEmailChangeDialogProps {
  open: boolean;
  account: AccountInfo;
  onClose: () => void;
  onCanceled: () => void;
}

/** Confirms dropping the pending primary-email change; the current email stays. */
export function CancelEmailChangeDialog({ open, account, onClose, onCanceled }: CancelEmailChangeDialogProps): React.JSX.Element {
  const { show } = useToast();
  return (
    <ConfirmDialog
      open={open}
      tone="warning"
      icon="mail"
      title="Cancel the email change"
      description={account.pendingEmail ? `The link we sent to ${account.pendingEmail} will stop working. You'll keep ${account.email}.` : undefined}
      confirmLabel="Cancel the change"
      cancelLabel="Keep waiting"
      onClose={onClose}
      onConfirm={async () => {
        try {
          await cancelPendingEmail();
          show({ title: "Email change canceled", tone: "success" });
          onCanceled();
        } catch (err) {
          show({ title: "We couldn't cancel it", text: emailErrorMessage(err, "Please try again."), tone: "danger" });
        }
      }}
    />
  );
}
